define('SageDotCom/Components/Blog/ArticleCollection', [
    "jquery",
    "matchHeight",
    "eventManager",
    "slick",
    "SageDotCom/DataLayer/Events/blog-click",
    'SageDotCom/Components/SlickSliderSettings',
    "SageDotCom/Utility/sageMatchHeight",
    "clamp"
], function ($, mh, eventManager, slick, blogClick, SlickSliderSettings, SageMatchHeight) {

    function ArticleCollection(args) {
        var scope = args.scope;
        var self = this;
            Object.defineProperty(this, "scope", { enumerable: true, value: scope, writable: !1 });
            Object.defineProperty(this, "$scope", { enumerable: !0, value: $(scope) });

            this.$scope.on('click', 'a', function (e) {
                var article = JSON.parse(e.currentTarget.dataset.tracking);
                new blogClick(article).trigger();
            });

            this.$scope.find("h2, p").each(function (i, item) {
                var $item = $(item);

                $item.attr('data-text-content', item.textContent);
                $item.attr("lang", document.documentElement.lang); 
            });

            scope.addEventListener('lazy-load-evt', function () {
                self._setSlider(args.SlidesToShow);
            });
        } 

        ArticleCollection.prototype._updateItems = function () {
            var self = this;

            this.$scope.find("h2").each(function (i, item) {
                self._doEllipsis(2, item);
            });

            this.$scope.find("p").each(function (i, item) {
                self._doEllipsis(3, item);
            });

            //could be initial matchHeight or update from new tag so use refresh as true when using applyBinding to make sure
            SageMatchHeight.prototype.applyBinding(this.$scope.find("article"), true, { byRow: false });
        }

        ArticleCollection.prototype._doEllipsis = function(lines, element) {
            var $element = $(element),
                inner = document.createElement('SPAN'),
                text = $element.attr('data-text-content'),
                textLength = $element.hasClass("article-title") ? 90 : 130;

            if (!text) return;

            element.innerHTML = "";
            element.style.height = 'auto';
            element.appendChild(inner);

            inner.textContent = text.length > textLength 
                ? text.substring(0, textLength) + "..." 
                : text;

            inner.style.display = 'block';
        }

        ArticleCollection.prototype._processSingleImage = function (image, imageHeights, $images) {
            var intervalVal = $(image).data("process-interval");

            if (image.complete && image.src !== "") {
                if (intervalVal) {
                    window.clearInterval(intervalVal);
                }

                imageHeights = this._addImageHeightToCollection(image, imageHeights, $images);
            } else {
                if (!intervalVal) {
                    var self = this;
                    intervalVal = window.setInterval(function() {
                            self._processSingleImage(image, imageHeights, $images);
                        },
                        20);
                    $(image).data("process-interval", intervalVal);
                }
            }
        }

        ArticleCollection.prototype._addImageHeightToCollection = function(image, imageHeights, $images) {
            imageHeights.push(image.height);

            if (imageHeights.length === $images.length) {
                this._setImageCropping($images, imageHeights);
            }

            return imageHeights;
        }

        ArticleCollection.prototype._setImageCropping = function($images, imageHeights) {
            var minHeight;
            
            minHeight = Math.min.apply(Math, imageHeights);

            $images.parent().height(minHeight);
            SageMatchHeight.prototype.applyBinding(this.$scope.find("article"), true, { byRow: false });
        }

        ArticleCollection.prototype._setSlider = function(slidesToShow) {
            var self = this;

            var slickSettings = SlickSliderSettings.getArticleCollectionSettings(slidesToShow); 

            new Promise(function(resolve, reject) {

                self.$scope.slick(slickSettings);

                self.$scope.on('init setPosition',
                    function() {
                        self._updateItems();
                    });

                eventManager.trigger("lazy-animate-element", self.$scope);

                resolve();
            });
        }

        ArticleCollection.init = function(args) {
            return new ArticleCollection(args);
        };

        return ArticleCollection;
});
